export const GET_LOCATION = "GET_LOCATION";
export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS";
export const GET_LOCATION_FAILURE = "GET_LOCATION_FAILURE";
export const MOBILE_SIDEBAR = "MOBILE_SIDEBAR";
export const RESET_LOCATION = "RESET_LOCATION";

export interface CommonState {
  mobileSidebar: boolean;
  locationList: any;

  getLocationError: string | null;
  getLocationLoading: boolean;
}

interface GetLocation {
  type: typeof GET_LOCATION;
  payload: any;
}

interface GetLocationSucess {
  type: typeof GET_LOCATION_SUCCESS;
  payload: any;
}

interface GetLocationFailure {
  type: typeof GET_LOCATION_FAILURE;
  payload: string;
}

interface MobileSidebar {
  type: typeof MOBILE_SIDEBAR;
  payload: boolean;
}

interface ResetGetLocation {
  type: typeof RESET_LOCATION;
}

export type CommonActionTypes =
  | GetLocation
  | GetLocationSucess
  | GetLocationFailure
  | MobileSidebar
  | ResetGetLocation;
